import { useSelector } from 'react-redux';

const useTemplateStyles = () => {
  const template = useSelector((state) => state.template);
  return template;
};

export default useTemplateStyles;
